/**
 * Normaliza registro de feedback_audio vindo da API/realtime (id vs feedback_audio_id).
 */
export function normalizeFeedbackAudioRecord(audio) {
  if (!audio || typeof audio !== 'object') return null;
  const rawId = audio.id ?? audio.feedback_audio_id ?? null;
  if (rawId == null || rawId === '') return null;
  const id = String(rawId);
  const filePath = audio.file_path || audio.path || '';
  return {
    ...audio,
    id,
    feedback_audio_id: audio.feedback_audio_id != null ? String(audio.feedback_audio_id) : id,
    file_path: filePath,
    path: audio.path || filePath,
  };
}

/**
 * Mescla listas de feedback_audio pelo id (evita duplicados ao fundir estado vindo da API e cópias locais).
 */
export function mergeFeedbackAudioListsById(...lists) {
  const map = new Map();
  for (const list of lists) {
    if (!Array.isArray(list)) continue;
    for (const raw of list) {
      const a = normalizeFeedbackAudioRecord(raw);
      if (!a) continue;
      map.set(String(a.id), a);
    }
  }
  return Array.from(map.values());
}

/**
 * Reúne todos os feedback_audios associados a um comentário no documento em memória
 * (correções aninhadas e competências/subcritérios).
 */
export function collectFeedbackAudiosForComentarioFromDocumento(documento, comentarioId) {
  if (!documento || comentarioId == null || comentarioId === '') {
    return [];
  }
  const id = String(comentarioId);
  const chunks = [];

  const correcoes = documento.correcoes || [];
  for (const cor of correcoes) {
    const avs = cor.avaliacoes_redacao || cor.avaliacoesRedacao || [];
    for (const av of avs) {
      const c = (av.comentarios || []).find((x) => x && String(x.id) === id);
      if (c) {
        chunks.push(c.feedback_audios || c.feedbackAudios || []);
      }
    }
    const c2 = (cor.comentarios || []).find((x) => x && String(x.id) === id);
    if (c2) {
      chunks.push(c2.feedback_audios || c2.feedbackAudios || []);
    }
  }

  const competencias = documento.competencias || [];
  for (const comp of competencias) {
    for (const c of comp.comentarios || []) {
      if (c && String(c.id) === id) {
        chunks.push(c.feedback_audios || c.feedbackAudios || []);
      }
    }
    for (const sc of comp.subcriterios || []) {
      for (const c of sc.comentarios || []) {
        if (c && String(c.id) === id) {
          chunks.push(c.feedback_audios || c.feedbackAudios || []);
        }
      }
    }
  }

  return mergeFeedbackAudioListsById(...chunks);
}
